import styled from 'styled-components';

export const StyledImageWrapper = styled.div`
    & .ab-scalable-product-card-isSmartphone {
        width: 75px;
        max-height: 85px;
        overflow: hidden;
    }
`;
